var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 46 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-958.36214)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    id: "use8412",
    transform: "matrix(-0.99999621,0,0,1,183.03467,790.10162)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#g8394",
    id: "use8402",
    transform: "translate(-65.756235,790.10162)",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path3379-7-3-6-2",
    id: "use8486",
    transform: "translate(56.243765,790.10162)",
    width: "100%",
    height: "100%"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#text3355-81-8",
    id: "use8488",
    transform: "translate(98.243765,790.10162)",
    width: "100%",
    height: "100%"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path5770-7-8-8",
    id: "use8490",
    transform: "translate(28.243765,790.10162)",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#g8408",
    id: "use8492",
    transform: "translate(230.24376,790.10162)",
    width: "100%",
    height: "100%"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#use8412",
    id: "use8494",
    transform: "translate(378,-1.0692717e-6)",
    width: "100%",
    height: "100%"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#text3355-81-8",
    id: "use8496",
    transform: "translate(230.24376,790.10162)",
    width: "100%",
    height: "100%"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#g8394",
    id: "use8498",
    transform: "translate(230.24376,790.10162)",
    width: "100%",
    height: "100%"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path3379-7-3-6-2",
    id: "use8500",
    transform: "translate(230.24376,790.10162)",
    width: "100%",
    height: "100%"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#path5770-7-8-8",
    id: "use8502",
    transform: "translate(230.24376,790.10162)",
    width: "100%",
    height: "100%"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#use8402",
    id: "use8504",
    transform: "translate(378,-1.0692717e-6)",
    width: "100%",
    height: "100%"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#use8486",
    id: "use8506",
    transform: "translate(378,-1.0692717e-6)",
    width: "100%",
    height: "100%"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#use8488",
    id: "use8508",
    transform: "translate(378,-1.0692717e-6)",
    width: "100%",
    height: "100%"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#use8490",
    id: "use8510",
    transform: "translate(378,-1.0692717e-6)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#00b8ff",
      stroke: "none",
      strokeWidth: 3.77637601,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m 21.474387,958.3621 c -6.41557,0 -11.6916606,4.69576 -11.6597626,10.44389 l 0.02544,3.73932 -5.2507503,0 0,3.95231 5.2724483,0 0.02953,4.94641 -5.0510092,0 0,3.95231 5.0728082,0 0.02953,5.93351 -5.1054508,0 0,3.95581 5.1272908,0 0.02544,4.6943 -5.0292467,0 0,3.95524 5.0509913,0 0.03952,6.809 c -6.2703329,4.2391 -10.0323796,11.2743 -10.051166,18.8023 5.588e-4,12.6022 10.297847,22.8156 23,22.8156 12.702156,0 22.99939,-10.2134 22.999999,-22.8156 -0.01499,-7.647 -3.886124,-14.78 -10.316279,-18.9967 l 0,-41.74381 c 0,-5.74813 -5.244067,-10.44389 -11.659712,-10.44389 l -2.549138,0 z m 0,4.53551 2.549143,0 c 3.697901,0 6.597862,2.59552 6.597862,5.90838 l 0,44.28701 0.145067,0 c -0.01,0.2414 -0.06002,0.4724 -0.134617,0.6918 5.907483,2.9512 9.636555,8.9512 9.644474,15.513 -2.49e-4,9.6043 -7.847206,17.39 -17.527809,17.39 -9.680605,0 -17.5275561,-7.7857 -17.5277619,-17.39 0.0011,-6.5664 3.7303073,-12.5721 9.6408579,-15.527 -0.01544,-0.055 -0.02953,-0.1105 -0.04453,-0.1658 0.02544,0 0.03952,0 0.06002,0 l 0,-44.78093 c 0,-3.31285 2.8964,-5.90837 6.594305,-5.90837 z m -0.261602,32.56086 c -1.314401,0 -2.371124,1.04835 -2.371124,2.3524 l 0,19.67433 c -5.146855,1.6745 -8.628156,6.4387 -8.631381,11.8126 1.03e-4,6.8708 5.613502,12.4401 12.538576,12.4401 6.925036,0 12.538435,-5.5693 12.538485,-12.4401 -0.0025,-5.4849 -3.627985,-10.3213 -8.921845,-11.9033 l 0,-19.58363 c 0,-1.30405 -1.056674,-2.3524 -2.371179,-2.3524 l -2.781532,0 z",
    id: "thermometer"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureLow);
export default __webpack_public_path__ + "static/media/TemperatureLow.6658495d32af25b680673a56cd839764.svg";
export { ForwardRef as ReactComponent };